/**
* @description
* # name controller --> enabledIndicatorsListController
* # As Controller --> enabledIndicatorsList
* brief comment controller shows the view for the main page of assignTimeRange
*/

export default class enabledIndicatorsListController {
	constructor($scope,enabledIndicatorsServices,ngNotify,UserInfoConstant,$state,$filter,indicatorsServices,levelsServices) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.services = enabledIndicatorsServices.services
		this.servicesPeriod = enabledIndicatorsServices.servicesPeriod
		this.indicatorsServices = indicatorsServices.services
		this.levelsServices = levelsServices.services
		this.$scope.buttonActions = false
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.$scope.periodSelect = null
		this.$scope.levelSelect = null
		this.indicatorName = null
		this.detailsEnabled ={
			enableFiltering: true
		}
		
		this.tableInitializeMethod()
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		this.params = {
			concept_id: this.conceptId
		}
		this.indicatorsLista()
		this.getPeriod()
		this.getLevels()
	}

	tableInitializeMethod() {
		this.detailsEnabled.columnDefs = [
			{field: 'indicatorCode', displayName: 'Cod Indicador', headerCellClass : 'text-center', },
			{field: 'levelName', displayName: 'Level', headerCellClass : 'text-center', },
			{field: 'periodName', displayName: 'Periodo', headerCellClass : 'text-center', },
			{field: 'createdAt', displayName: 'Fecha Habilitación', headerCellClass : 'text-center', },
		]
	}

	indicatorsLista(){
		this.indicatorsServices.getIndicators(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.indicators = []
				this.indicatorsList = dataReturn.results;
				for (let i in this.indicatorsList){
					this.indicators.push({
						title: this.indicatorsList[i].ds_name,
						id_code: this.indicatorsList[i].id_code,
						cod: this.indicatorsList[i].ds_code,
						coreName: this.indicatorsList[i].core ? this.indicatorsList[i].core.ds_name : null,
						badges: [
							{
								label: ( (this.indicatorsList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.indicatorsList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getPeriod(){
		this.servicesPeriod.getPeriod().$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.periodList = dataReturn.results
				this.periodList.map((period) => {
					if(period.is_current ){
						this.$scope.periodSelect = period.id_code
					}
				})

				this.params.period_id = this.$scope.periodSelect
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getLevels(){
		this.levelsServices.getLevels(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.levelsList = dataReturn.results
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getEnabledIndicator(params){
		this.services.getEnabledIndicators(params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.detailsEnabled.data = this.setAllDataEnabledIndicator(dataReturn.results)
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	setAllDataEnabledIndicator(enabledIndicators) {
		return enabledIndicators.map(enabled => {
			return {
				enabledId: enabled.id_code,
				indicatorCode: enabled.indicator.ds_code,
				indicatorId: enabled.indicator.id_code,
				levelName: enabled.level.ds_name,
				levelId: enabled.level.id_code,
				periodName: enabled.period.ano,
				periodId: enabled.period.id_code,
				createdAt: enabled.createdAt			
			}
		})
	}

	selectChanged(periodSelect){
		this.$scope.periodSelect = periodSelect
		this.params.period_id = periodSelect

		if(this.panelConfig){
			this.getEnabledIndicator(this.params)
		}
	}

	onClick(item){
		this.getDetailsFunction(item);
		this.panelConfig = true
		this.$scope.buttonActions = true
	}

	getDetailsFunction(params){
		this.indicatorName = params.title
		this.indicatorId = params.id_code
		this.params.indicator_id = params.id_code
		this.params.period_id = this.$scope.periodSelect
		this.getEnabledIndicator(this.params)

	}

	edit(){
		this.$scope.editSave = true
		this.$scope.edit = false
		this.$scope.titleList = false
		this.$scope.titleEdit = true
		this.$scope.isDisabled = false
		this.$scope.levelSelect = null
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.panelConfig = false
		this.$scope.buttonActions = false
		this.getDetailsFunction({student_id : this.studentId});
		
	}

	saveEdit(){
		if(this.$scope.levelSelect === null) {
			this.ngNotify.set('Seleccione un Nivel','warn')
			return
		}

		let params  = {
			period_id   : this.$scope.periodSelect,
			user_id : this.user_id,
			concept_id: this.conceptId,
			level_id: this.$scope.levelSelect,
			indicator_id: this.indicatorId
		}

		this.services.saveEnabledIndicators(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se habilitó correctamente el Indicador','success')
				this.$scope.levelSelect = null
				this.getEnabledIndicator(this.params)

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Existe habilitación de Indicador para periodo seleccionado','warn');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Existe habilitación de Indicador para periodo seleccionado','warn');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
enabledIndicatorsListController.$inject=['$scope', 'enabledIndicatorsServices', 'ngNotify','UserInfoConstant','$state','$filter', 'indicatorsServices', 'levelsServices']


// WEBPACK FOOTER //
// ./src/app/admin-panel/enabledIndicators/list/enabledIndicatorsListController.js